module.exports = __webpack_public_path__ + "img/45.adfe3534.jpg";